module.exports = __webpack_public_path__ + "img/claims.45c18c44.svg";